import { useCallback, useState } from 'react';

import { IDefaultValue } from '../../../models/DefaultValue';

const INITIAL_FORM_DEFAULT_VALUE: IDefaultValue = {
    sid: '',
    key: '',
    value: '',
    contain_key: '',
};

function useDefaultValueModal() {
    const [modalState, setModalState] = useState<{
        isOpen: boolean;
        title: string;
        buttonText: string;
        defaultValue?: IDefaultValue;
        formDefaultValue: IDefaultValue;
        confirmFunction?: (defaultValue: IDefaultValue) => void;
    }>({
        isOpen: false,
        title: '',
        buttonText: '',
        formDefaultValue: INITIAL_FORM_DEFAULT_VALUE,
    });

    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const { name, value } = event.target;

            setModalState((prevState) => ({
                ...prevState,
                formDefaultValue: {
                    ...prevState.formDefaultValue,
                    [name]: value,
                },
            }));
        },
        []
    );

    const openModal = useCallback(
        (
            title: string,
            buttonText: string,
            defaultValue?: IDefaultValue,
            confirmFunction?: (defaultValue: IDefaultValue) => void,
            initialFormValue?: Partial<IDefaultValue>
        ) => {
            setModalState({
                isOpen: true,
                title,
                buttonText,
                defaultValue,
                formDefaultValue: defaultValue ?? { ...INITIAL_FORM_DEFAULT_VALUE, ...initialFormValue },
                confirmFunction,
            });
        },
        []
    );

    const handleSidChange = useCallback((sid: string) => {
        setModalState(prev => ({
            ...prev,
            formDefaultValue: { ...prev.formDefaultValue, sid },
        }));
    }, []);

    const closeModal = useCallback(() => {
        setModalState((prev) => ({
            ...prev,
            isOpen: false,
            defaultValue: undefined,
        }));
    }, []);

    return {
        modalState,
        openModal,
        closeModal,
        handleChange,
        handleSidChange,
    };
}

export default useDefaultValueModal;
